export const pageType = {
  dashboard: 'Dashboard',
  bookingDetailPage: 'Booking Details Page',
  bookingListPage: 'Booking List Page',
  studentListPage: 'Student List Page',
  studentDetailPage: 'Student Details Page',
  loginPage: 'Login Page',
  tutorial: 'Tutorial',
  resetPasswordPage: 'Reset Password Page',
  onBoardingPage: 'Onboarding Page',
  paymentPlanPage: 'Payment Plan Page',
  myProfilePage: 'My Profile Page',
  helpCenterPage: 'Help Center Page',
  propertyListPage: 'Property List Page',
  propertyHomePage: 'Property Home Page',
  propertyManagePage: 'Property Management Page',
  propertyTermPage: 'Property Term Page',
  propertyContractPage: 'Property Contract Page',
  propertyCommissionPage: 'Property Commission Page',
  payOutsPage: 'Payouts Page',
};
